import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {PATHS} from '../../../../Routes';
import {useCartDeals} from '../../../../hooks/useCartDeals';
import {useComputedReservationDetails} from '../../../../context/computedReservationDetails';
import {getFinishCheckinHistoryArgs} from '../../../../utils/checkin';
import {ButtonStyled, Title, Wrapper} from './styled';

type PaymentFixedButtonProps = {
  onError: () => void;
};
function PaymentFixedButton({onError}: PaymentFixedButtonProps) {
  const {t} = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const reservationDetails = useComputedReservationDetails();
  const {storedCartDeals, createCartDeals, isCreatingCartDeals} = useCartDeals({onError});
  const hasCartDeals = Boolean(Object.keys(storedCartDeals).length);

  const goNextAfterUpselling = (dealsCreated = false) => {
    if (reservationDetails.hasTaxes) {
      history.push(PATHS.touristTaxes, location.state);
      return;
    }

    if (dealsCreated) {
      history.push(PATHS.pay, location.state);
      return;
    }

    const args = getFinishCheckinHistoryArgs({
      reservationDetails,
      locationState: location.state,
    });

    history.push(args.url, args.state);
  };

  const handleGoPayment = async () => {
    if (hasCartDeals) {
      const isError = await createCartDeals();

      if (!isError) {
        goNextAfterUpselling(true);
      }

      return;
    }

    goNextAfterUpselling();
  };

  if (!hasCartDeals) return null;

  return (
    <Wrapper>
      <Title>{t('are_you_done')}</Title>
      <ButtonStyled
        label={t('go_to_payment')}
        onClick={handleGoPayment}
        iconRight="arrowNext"
        disabled={isCreatingCartDeals}
      />
    </Wrapper>
  );
}

export default React.memo(PaymentFixedButton);
